var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_563_17895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66679 9.6C6.66679 8.82204 6.97584 8.07593 7.52595 7.52582C8.07605 6.97572 8.82216 6.66667 9.60013 6.66667H10.9335C11.708 6.66623 12.4509 6.35947 13.0001 5.81334L13.9335 4.88C14.2061 4.60587 14.5302 4.38833 14.8871 4.23988C15.2441 4.09143 15.6269 4.01501 16.0135 4.01501C16.4001 4.01501 16.7828 4.09143 17.1398 4.23988C17.4968 4.38833 17.8209 4.60587 18.0935 4.88L19.0268 5.81334C19.5761 6.36 20.3201 6.66667 21.0935 6.66667H22.4268C23.2048 6.66667 23.9509 6.97572 24.501 7.52582C25.0511 8.07593 25.3601 8.82204 25.3601 9.6V10.9333C25.3601 11.7067 25.6668 12.4507 26.2135 13L27.1468 13.9333C27.4209 14.2059 27.6385 14.53 27.7869 14.887C27.9354 15.244 28.0118 15.6267 28.0118 16.0133C28.0118 16.3999 27.9354 16.7827 27.7869 17.1397C27.6385 17.4966 27.4209 17.8207 27.1468 18.0933L26.2135 19.0267C25.6673 19.5759 25.3606 20.3188 25.3601 21.0933V22.4267C25.3601 23.2046 25.0511 23.9507 24.501 24.5009C23.9509 25.051 23.2048 25.36 22.4268 25.36H21.0935C20.3189 25.3604 19.576 25.6672 19.0268 26.2133L18.0935 27.1467C17.8209 27.4208 17.4968 27.6383 17.1398 27.7868C16.7828 27.9352 16.4001 28.0117 16.0135 28.0117C15.6269 28.0117 15.2441 27.9352 14.8871 27.7868C14.5302 27.6383 14.2061 27.4208 13.9335 27.1467L13.0001 26.2133C12.4509 25.6672 11.708 25.3604 10.9335 25.36H9.60013C8.82216 25.36 8.07605 25.051 7.52595 24.5009C6.97584 23.9507 6.66679 23.2046 6.66679 22.4267V21.0933C6.66635 20.3188 6.3596 19.5759 5.81346 19.0267L4.88013 18.0933C4.60599 17.8207 4.38845 17.4966 4.24 17.1397C4.09156 16.7827 4.01514 16.3999 4.01514 16.0133C4.01514 15.6267 4.09156 15.244 4.24 14.887C4.38845 14.53 4.60599 14.2059 4.88013 13.9333L5.81346 13C6.3596 12.4508 6.66635 11.7079 6.66679 10.9333V9.6Z",
    stroke: "#19BB7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16L14.6667 18.6667L20 13.3334",
    stroke: "#19BB7A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_563_17895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.12548ef21a7fa283878b190351c8bdae.svg";
export { ForwardRef as ReactComponent };